// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-SearchBar-style__root__TyvLk{padding:20px}.components-SearchBar-style__root__TyvLk input[type=search]{font-size:inherit;border-radius:2rem;border:none;background-color:#fff;padding:10px 20px;display:block;width:100%;-webkit-box-shadow:3px 2px 8px #9b9b9b;box-shadow:3px 2px 8px #9b9b9b}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `components-SearchBar-style__root__TyvLk`
};
export default ___CSS_LOADER_EXPORT___;
